import * as React from 'react';

const Internal: React.FunctionComponent<{}> = () => {
  return (
    <h1>Internal</h1>
  );
};

export default Internal;
